import { Observable } from 'rxjs';
import { UnifiedEntityResults, EntitySearchOptions } from './unified-search.model';

/**
 * Seam between the search UI and its data source. `MockSearchGateway` (now)
 * runs on real ES + client-merge + fixtures; `RealSearchGateway` (later)
 * uses the enriched index. The UI depends only on this abstract class.
 */
export abstract class SearchGateway {
  abstract search(query: string, options?: EntitySearchOptions): Observable<UnifiedEntityResults>;
}
